import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useParticipant, FeedbackData } from '../../contexts/ParticipantContext';
import FeedbackForm from '../../components/participant/FeedbackForm';
import { BrCard } from '@govbr-ds/react-components';

export default function ParticipantFeedbackPage() {
    const navigate = useNavigate();
    const { taskIndex } = useParams<{ taskIndex: string }>();
    const { state, submitFeedback, isLastTask } = useParticipant();

    const currentTaskIndex = parseInt(taskIndex || '0', 10);

    // Handle redirect in useEffect instead of during render
    useEffect(() => {
        const timer = setTimeout(() => {
            if (!state.session && !state.isLoading) {
                navigate('/participante');
            }
        }, 100);
        return () => clearTimeout(timer);
    }, [state.session, state.isLoading, navigate]);

    if (!state.session) {
        return (
            <div className="container-lg py-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8 text-center">
                        <p className="text-gray-500">Carregando...</p>
                    </div>
                </div>
            </div>
        );
    }

    const handleSubmit = async (feedback: FeedbackData) => {
        await submitFeedback(feedback);

        if (isLastTask()) {
            navigate('/participante/obrigado');
        } else {
            navigate(`/participante/tarefa/${currentTaskIndex + 1}`);
        }
    };

    const tasksRemaining = (state.session.assigned_tasks.length || 3) - currentTaskIndex - 1;

    return (
        <div className="container-lg py-4">
            <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-8">
                    <BrCard>
                        {/* Task indicator */}
                        <div className="text-center mb-4 text-sm text-gray-60">
                            Avaliação da Tarefa {currentTaskIndex + 1} de {state.session.assigned_tasks.length || 3}
                            {!isLastTask() && (
                                <span className="block text-xs mt-1">
                                    {tasksRemaining} tarefa{tasksRemaining > 1 ? 's' : ''} restante{tasksRemaining > 1 ? 's' : ''}
                                </span>
                            )}
                        </div>

                        <FeedbackForm
                            onSubmit={handleSubmit}
                            isLoading={state.isLoading}
                            isLastTask={isLastTask()}
                        />

                        {state.error && (
                            <div className="mt-4 bg-danger border-l-4 border-danger p-4 text-pure-0">
                                {state.error}
                            </div>
                        )}
                    </BrCard>
                </div>
            </div>
        </div>
    );
}
